function UserSecurityAnswer() {
    "use strict";

    this.__type = 'UserSecurityAnswer:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.UserId = -1;
    this.SecurityQuestionId = -1;
    this.SecurityAnswer = '';
}
if (typeof exports !== 'undefined') {
    module.exports = UserSecurityAnswer;
}